<template>
  <div class="wrap-helper-show g-flex-column-sb">
    <div :style="{ height:bannerHeight+'px', background: `url(${imgPath}${topBanner}) no-repeat`}" class="banner" >
      <div class="shop g-flex-c" @click="handleSign"><span>立即报名</span></div>
      <div class="shopOil g-flex-c"><img :src="`${$ossUrl}active/daySpecial/fire.png`" alt="">{{count || 0}}座油站累计参加</div>
    </div>
    <div class="left-word" v-for="(item,index) in caseInfo[page]" :key="index">
      <template v-if="item.isImgLeft">
        <div class="con-wrap g-flex-c">
          <img :src="imgPath+item.img" alt="">
          <div>
            <div>{{item.title}}</div>
            <div class="word">{{item.info}}</div>
          </div>
        </div>·
      </template>
      <template v-else>
        <div :class="[item.img === 'traffic.png' ? 'special-con-wrap' : 'con-wrap', 'g-flex-c']">
          <div>
            <div class="left-show">{{item.title}}</div>
            <div class="word left-show">{{item.info}}</div>
          </div>
          <img :src="imgPath+item.img" alt="">
        </div>
      </template>
    </div>
    <Footer/>
    <agreement ref="agreement" :router="'/promotion/daySpecialSign'" :type="7"/>
  </div>
</template>
<script>
import { check, joinCompanyNum, checkGasSale } from '@/api/marketPromotion'
import agreement from './agreement'
import mixins from './mixin'
import Footer from './footer'
export default {
  mixins: [mixins],
  components: {
    Footer,
    agreement
  },
  data() { 
    const _this = this
    return {
      count: '', // 参与商家数
      bannerHeight: 400,
      page:'care',
      imgPath: `${_this.$ossUrl}active/daySpecial/`,
      topBanner: 'daybanner.png',
      caseInfo:{
        care: [
          {
            img:'rightOne.png',
            isImgLeft: false,
            title: '千万级用户体量',
            info:'团油拥有千万级活跃车主，为天天特价活动提供充足消费保障，为您的油站销量加油助力。'
          },
          {
            img:'leftSec.png',
            isImgLeft: true,
            title: '油站专属券',
            info:'锁客复购，参与活动的用户完成当笔订单后，系统默认为用户推送油站专属优惠券，让用户再次来到站内加油。'
          },
          // {
          //   img:'leftThir.png',
          //   isImgLeft: false,
          //   title: '油站置顶',
          //   info:'强曝光+强引流，活动期间可根据您的需求选择是否需要油站置顶，通过一定范围内的置顶来更好的宣传活动。'
          // },
          {
            img:'filterTab.png',
            isImgLeft: false,
            title: '快筛标签',
            info:'“天天特价”标签，让车主快速筛选定位到油站，引导车主到站加油。'
          }
        ]
      }
    } 
  },
  mounted () {
    this.$track.pageViewEvent('1', 1632832578)
    this.joinCompanyNumApi()
  },
  methods: {
    // 报名跳转
    async handleSign () {
      this.$track.clickEvent('立即报名', 1632832579, { tysj_trade_type: 1 })

      const resGasSale = await checkGasSale()
      if (!resGasSale.result) {
        return this.$message.info('未查询到人站关系，继续报名会失败，请联系您的客户经理')
      }
      const { code, result: { signed, title, content } } = await check({ activityType: 7 }) // 7-天天特价 8-加油送水 9-限时秒杀
      if(code !== 200) return
      // 如果已经看过协议了，就不用看了，直接跳转到表单页
      if(signed) {
        this.$router.push({ path: '/promotion/daySpecialSign' })
      } else {
        this.$refs.agreement.init(title, content)
      }
    },
    setSize () {
      // 通过浏览器宽度(图片宽度)计算高度
      if(this.screenWidth < 1080) return
      this.bannerHeight = 400 / 1920 * this.screenWidth;
    },
    async joinCompanyNumApi () {
      try {
        const { code, result } = await joinCompanyNum()
        if (code !== 200) return
        result.forEach(item => {
          if(item.activityType === 7) {
            this.count = item.joinActivityCount
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap-helper-show{
  width: 100%;
  padding: 10px 0;
  background: #F8F9FD;
}
.banner{
  width: 100%;
  position: relative;
  background-size: 100%!important;
  margin-bottom: 10px;
  .shop{
    position: absolute;
    width: 192px;
    top: 60%;
    left: 5%;
    height: 48px;
    background: #FFC73A;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #4D14CB;
    cursor: pointer;
    border-radius: 4px;
    >img{
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .shopOil{
    position: absolute;
    top: 85%;
    left: 5%;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    >img{
      display: block;
      width: 12px;
      height: 16px;
      margin-right: 10px;
    }
  }
}
.left-word{
  width: 100%;
  display: flex;
  justify-content: space-around;
  background: #fff;
  margin: 10px 0;
  .special-con-wrap {
    width: 92%;
    height: 340px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
    >div{
      width: 400px;
      margin: 0 20px;
    }
    >img{
      display: block;
      width: 640px;
      height: 183px;
      margin: 0 20px;
    }
    .word{
      font-size: 16px;
      line-height: 25px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .left-show{
      text-align: right;
    }
  }
  .con-wrap {
    width: 80%;
    height: 340px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
    >div{
      width: 360px;
      margin: 0 20px;
    }
    >img{
      display: block;
      width: 400px;
      height: 181px;
      margin: 0 20px;
    }
    .word{
      font-size: 16px;
      line-height: 25px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .left-show{
      text-align: right;
    }
  }
}
</style>